module.exports = __webpack_public_path__ + "img/services-08.12e4ab0c.jpg";